// A hash-only change is a same-document SPA navigation, so anything relying
// on a full page load (e.g. tearing down the session-expired overlay, which
// is appended directly to document.body outside Angular's view) won't see
// it. A full reload guarantees a clean slate instead of racing Angular's
// route render.
export function redirectToLogin(): void {
  window.location.hash = '/login';
  window.location.reload();
}
